import React, { memo, useMemo, useCallback } from 'react';
import { createUseStyles, Text, Icon, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../../../../../lib/Web5Context";
import { CHART_TYPES, NOT_CHART_TYPES } from "../../../../constants";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'StepsInfo');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "addPlus"
});
var _ref3 = /*#__PURE__*/React.createElement(Icon, {
  name: "dateRange"
});
var _ref4 = /*#__PURE__*/React.createElement(Icon, {
  name: "percentage"
});
const StepsInfo = /*#__PURE__*/memo(_ref => {
  let {
    data,
    onReturnToMainTab
  } = _ref;
  const theme = useTheme();
  const classes = useStyles();
  const {
    t,
    getWeb4EntityFromString
  } = useWeb5Context();
  const chartPlaceholder = useMemo(() => {
    const chartTypes = {
      [CHART_TYPES.bar]: 'verticalBarChartColor',
      [CHART_TYPES.hBar]: 'horizontalBarChartColor',
      [CHART_TYPES.line]: 'linesChartColor',
      [CHART_TYPES.pie]: 'pieChartColor',
      [CHART_TYPES.area]: 'areaChartColor',
      [CHART_TYPES.doughnut]: 'radialBarChartColor',
      [NOT_CHART_TYPES.kpi]: 'counterChartColor',
      [NOT_CHART_TYPES.table]: 'tableChartColor',
      [NOT_CHART_TYPES.map]: 'mapChartColor'
    };
    return /*#__PURE__*/React.createElement("div", {
      className: classes.chartType
    }, /*#__PURE__*/React.createElement(Icon, {
      className: classes.chartTypeIcon,
      name: chartTypes[data === null || data === void 0 ? void 0 : data.chartType]
    }));
  }, [data === null || data === void 0 ? void 0 : data.chartType, classes.chartType, classes.chartTypeIcon]);
  const getIcon = useCallback(entity => {
    const specialEntity = {
      internetEmails: 'email',
      phoneCalls: 'localPhone',
      salesorders: 'salesOrders'
    };
    let finalName = entity;
    if (specialEntity[entity]) finalName = specialEntity[entity];
    return /*#__PURE__*/React.createElement(Icon, {
      name: finalName,
      color: theme.colors.semantic.info400
    });
  }, [theme.colors]);
  const entityPlaceholder = useMemo(() => {
    var _data$entity, _data$entity2, _data$entity3;
    const hasData = !!(data !== null && data !== void 0 && (_data$entity = data.entity) !== null && _data$entity !== void 0 && _data$entity.value);
    const entity = getWeb4EntityFromString(data === null || data === void 0 ? void 0 : (_data$entity2 = data.entity) === null || _data$entity2 === void 0 ? void 0 : _data$entity2.value);
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.box, {
        [classes.incomplete]: !hasData
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxLeft
    }, hasData && (entity === null || entity === void 0 ? void 0 : entity.trueName) && getIcon(entity.trueName), !hasData && _ref2), /*#__PURE__*/React.createElement("div", {
      className: classes.boxRight
    }, hasData && /*#__PURE__*/React.createElement(Text, {
      isTruncated: true
    }, (data === null || data === void 0 ? void 0 : (_data$entity3 = data.entity) === null || _data$entity3 === void 0 ? void 0 : _data$entity3.label) || ''), !hasData && /*#__PURE__*/React.createElement(Text, {
      color: !hasData ? theme.colors.textLight.secondary : ''
    }, t('label_forcebi_crud_placeholder_select_entity'))));
  }, [data, classes.box, classes.boxLeft, classes.boxRight, classes.incomplete, t, getWeb4EntityFromString, getIcon, theme]);
  const yPlaceholder = useMemo(() => {
    const hasData = !!(data !== null && data !== void 0 && data.yAxis);
    let content = /*#__PURE__*/React.createElement(Text, {
      color: !hasData ? theme.colors.textLight.secondary : ''
    }, t('label_select_y_axis_value'));
    if (hasData) {
      var _data$yAxis;
      content = /*#__PURE__*/React.createElement(Text, null, (data === null || data === void 0 ? void 0 : (_data$yAxis = data.yAxis) === null || _data$yAxis === void 0 ? void 0 : _data$yAxis.label) || '');
    }
    const iconName = hasData ? 'yAxisColor' : 'yAxis';
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.box, {
        [classes.incomplete]: !hasData
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxLeft
    }, /*#__PURE__*/React.createElement(Icon, {
      name: iconName
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.boxRight
    }, content));
  }, [data === null || data === void 0 ? void 0 : data.yAxis, classes.box, classes.boxLeft, classes.boxRight, classes.incomplete, t, theme]);
  const xPlaceholder = useMemo(() => {
    const hasData = !!(data !== null && data !== void 0 && data.xAxis);
    let content = /*#__PURE__*/React.createElement(Text, {
      color: !hasData ? theme.colors.textLight.secondary : ''
    }, t('label_select_x_axis_value'));
    if (hasData) {
      var _data$xAxis;
      content = /*#__PURE__*/React.createElement(Text, null, (data === null || data === void 0 ? void 0 : (_data$xAxis = data.xAxis) === null || _data$xAxis === void 0 ? void 0 : _data$xAxis.label) || '');
    }
    const iconName = data !== null && data !== void 0 && data.xAxis ? 'xAxisColor' : 'xAxis';
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.box, {
        [classes.incomplete]: !hasData
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxLeft
    }, /*#__PURE__*/React.createElement(Icon, {
      name: iconName
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.boxRight
    }, content));
  }, [data === null || data === void 0 ? void 0 : data.xAxis, classes.box, classes.boxLeft, classes.boxRight, classes.incomplete, t, theme]);
  const shouldRenderXAxisAggregationDatePlaceholder = useMemo(() => {
    var _data$xAxis2;
    if (data !== null && data !== void 0 && (_data$xAxis2 = data.xAxis) !== null && _data$xAxis2 !== void 0 && _data$xAxis2.isDateField) return true;
    return false;
  }, [data === null || data === void 0 ? void 0 : data.xAxis]);
  const xAxisAggregationDatePlaceholder = useMemo(() => {
    const hasData = !!(data !== null && data !== void 0 && data.xAxisAggregationDate);
    let content = /*#__PURE__*/React.createElement(Text, {
      color: !hasData ? theme.colors.textLight.secondary : ''
    }, t('label_select_aggregation_date'));
    if (hasData) {
      var _data$xAxisAggregatio;
      content = /*#__PURE__*/React.createElement(Text, null, (data === null || data === void 0 ? void 0 : (_data$xAxisAggregatio = data.xAxisAggregationDate) === null || _data$xAxisAggregatio === void 0 ? void 0 : _data$xAxisAggregatio.label) || '');
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.box, {
        [classes.incomplete]: !hasData
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxLeft
    }, _ref3), /*#__PURE__*/React.createElement("div", {
      className: classes.boxRight
    }, content));
  }, [data === null || data === void 0 ? void 0 : data.xAxisAggregationDate, classes.box, classes.boxLeft, classes.incomplete, classes.boxRight, t, theme]);
  const yAxisAggregationPlaceholder = useMemo(() => {
    const hasData = !!(data !== null && data !== void 0 && data.yAxisAggregation);
    let content = /*#__PURE__*/React.createElement(Text, {
      color: !hasData ? theme.colors.textLight.secondary : ''
    }, t('label_select_aggregation_method'));
    if (hasData) {
      var _data$yAxisAggregatio;
      content = /*#__PURE__*/React.createElement(Text, null, (data === null || data === void 0 ? void 0 : (_data$yAxisAggregatio = data.yAxisAggregation) === null || _data$yAxisAggregatio === void 0 ? void 0 : _data$yAxisAggregatio.label) || '');
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.box, {
        [classes.incomplete]: !hasData
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxLeft
    }, _ref4), /*#__PURE__*/React.createElement("div", {
      className: classes.boxRight
    }, content));
  }, [data === null || data === void 0 ? void 0 : data.yAxisAggregation, classes.box, classes.boxLeft, classes.incomplete, classes.boxRight, t, theme]);
  const line = useMemo(() => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.line
    });
  }, [classes.line]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, entityPlaceholder, line, yPlaceholder, line, xPlaceholder, line, shouldRenderXAxisAggregationDatePlaceholder && xAxisAggregationDatePlaceholder, shouldRenderXAxisAggregationDatePlaceholder && line, yAxisAggregationPlaceholder, line, chartPlaceholder);
});
export default StepsInfo;